import type {Editor} from 'grapesjs';
interface ToolbarPos {
  top?: string | number;
  left?: string | number;
  bottom?: string | number;
  right?: string | number;
}

export function initDescriptionRtePositioner(editor: Editor): void {
  editor.on('rteToolbarPosUpdate', (pos: ToolbarPos): void => {
    pos.top = 'calc(100% + 8px)';
    pos.left = '0';
    pos.bottom = undefined;
    pos.right = undefined;
  });
}
